export const jobs = [
    {
        company: "Freelance",
        title: "Freelancer",
        date: "November 2020 - Current",
        description: "Coordinating closely with clients to deliver applications that satisfy their needs. Selected the best technologies to support the product. Developed custom user interfaces on the frontend using React and SCSS."
    },
    {
        company: "Lambda",
        title: "Team Lead",
        date: "February 2020 - June 2020",
        description: "Managed a team of seven students, emulating a real work environment using the agile methodology. Reviewed projects in one on one meetings and supplied students with technical support and provided additional resources to reassure their understanding of the concepts."

    },

    {
        company: "Connect Our Kids",
        title: "React Native Developer - Intern",
        date: "December 2019 - February 2020",
        description: "Developing the React Native codebase for iOS and Android platforms. Introducing new features while maintaining existing People Search and Family Connection APIs. Transitioning the existing web application features to React Native for use on mobile."

    }
]
export const skills = [
    {
        name: "",
        img: ""
    },
]
export const education = [

    {
        school: "Lambda",
        major: "Full Stack Web Development",
        date: "April 2020",
    },

    {
        school: "California State Polytechnic University, Pomona",
        major: "Hospitality Management, Computer Information System minor",
        date: "December 2018",
    }
]

export const projects = [
    {
        name: "Tabless Thursday",
        primaryTag: "UI",
        description: "An app that saves tabs and does away with the clutter and memory usage that traditional tabs bring",
        img: "images/projects/tablessCard.PNG",
        descriptionImg: "images/projects/tabless.PNG",
        src: "https://tabless-project.netlify.com/",
        tags: "HTML CSS LESS",
        gh: "https://github.com/Tabless-Thursday1/Tabless-UI-3"
    },
    {
        name: "Tech Jobs",
        primaryTag: "React",
        description: "A frontend application that uses the GitHub API to browse for jobs.",
        img: "images/projects/jobCard.png",
        descriptionImg: "images/projects/job.png",
        src: "https://uziasr.github.io/job-app/",
        tags: " React GitHub API HTML CSS",
        gh: "https://github.com/uziasr/job-app"
    },
    {
        name: "Kickstarter Success",
        primaryTag: "Front End React",
        description: "An app that calculates the likelihood of success for a kickstarter post.",
        img: "images/projects/ksCard.PNG",
        descriptionImg: "images/projects/ks.PNG",
        src: "https://kickstart-success.netlify.com/",
        tags: "React Redux",
        gh: "https://github.com/Kickstarter-Success/Frontend"
    },
    {
        name: "Checkers Pro",
        primaryTag: "React",
        description: "A simple checkers game made entirely with react",
        img: "images/projects/checkers-pro.png",
        descriptionImg: "images/projects/checkers-proCard.png",
        src: "https://checkers-pro.vercel.app/",
        tags: "React HTML CSS",
        gh: "https://github.com/uziasr/checkers-pro",
    },
    {
        name: "Heat Unit",
        primaryTag: "Back End Django",
        description: "A game where as a chile pepper, you battle the spiciest peppers with goal to be spiciest of them all",
        img: "images/projects/spicyCard.PNG",
        descriptionImg: "images/projects/spicy.PNG",
        src: "https://front-end.bayronpuac.now.sh/",
        tags: "Python Django Redux",
        gh: "https://github.com/CS26-Heat-Unit"
    },
    {
        name: "Form Critic",
        primaryTag: "FullStack",
        description: "A platform where people can get their exercise form checked by certified personal trainers and by the community as a whole.",
        img: "images/projects/fromCriticCard.PNG",
        descriptionImg: "images/projects/formCritic.png",
        src: "https://form-critic.uziasrivera.now.sh/",
        tags: "React Redux Node.js Express Knex",
        gh: "https://github.com/uziasr/frontend/tree/master"
    },
    {
        name: "Connect Our Kids",
        primaryTag: "React Native",
        description: "Interned as a react native developer. Developed multiple screens, forms, and styled according to design schematics",
        img: "images/projects/connect.png",
        descriptionImg: "images/projects/connectocCard.png",
        src: "https://www.connectourkids.org/",
        tags: "React Native Redux",
        gh: "https://github.com/",
    },
    {
        name: "Job Board Pro",
        primaryTag: "React Flask MongoDB BeautifulSoup",
        description: "A job board application that allows users to save their job applications. They have the ability to categorize the job and update its status. The save job form supports web scrapping of sites like indeed and others list on the page. This site comes packed with visualizations as well.",
        img: "images/projects/jobBoardPro.JPG",
        descriptionImg: "images/projects/jobBoardProCard.JPG",
        src: "https://job-board-fe-gf1wxp4vh.vercel.app/",
        tags: "React  Redux Flask MongoDB BeautifulSoup",
        gh: "https://github.com/uziasr/job-board-FE",
    },
    {
        name: "Free Games TS",
        primaryTag: "TypeScript React",
        description: "A list of free games to spend your free time with.",
        img: "images/projects/FreeGamesTS.JPG",
        descriptionImg: "images/projects/FreeGamesTSCard.JPG",
        src: "https://5fdc0a32d6e37200079d64dd--relaxed-gates-cddd8a.netlify.app/",
        tags: "TypeScript React",
        gh: "https://github.com/?q=game",
    },
    {
        name: "The Daily Post",
        primaryTag: "TypeScript Graphql Next.js",
        description: "A public forum for civic discussion",
        img: "images/projects/dailyPostCard.JPG",
        descriptionImg: "images/projects/dailyPost.JPG",
        src: "https://daily-post-web.vercel.app/",
        tags: "Typescript Graphql Next.js Chakra Urql",
        gh: "https://github.com/uziasr/daily_post_api",
    },
    {
        name: "The Settlers of Katan",
        primaryTag: "React JavaScript boardgame.io",
        description: "A board game like the Settlers of Catan, remote multiplayer feature still in the works",
        img: "images/projects/Katan.JPG",
        descriptionImg: "images/projects/KatanCard.JPG",
        src: "https://settlers.vercel.app/",
        tags: "React JavaScript boardgame.io",
        gh: "https://github.com/uziasr/settlers",
    },
    {
        name: "Paper Trail",
        primaryTag: "React redux Node.js",
        description: "An application to collect your train of thoughts. Perfect for recording your research. Chrome extension in the works",
        img: "images/projects/PaperTrails.JPG",
        descriptionImg: "images/projects/PaperTrail.JPG",
        src: "https://paper-trails.vercel.app/",
        tags: "React redux Node.js",
        gh: "https://github.com/uziasr/paper_trails",
    },
        {
        name: "Ecommerce",
        primaryTag: "React Stripe Commerce.js",
        description: "Simply designed e-commerce web application. Powered by the powerful Commerce.js",
        img: "images/projects/ecommerceCard.JPG",
        descriptionImg: "images/projects/ecommerce.JPG",
        src: "https://ecommerce-office.netlify.app/",
        tags: "React Stripe Commerce.js Material UI",
        gh: "https://github.com/uziasr/ecommerce_site",
    }
    // {
    //     name: "",
    //     primaryTag: "",
    //     description: "",
    //     img: "",
    //     descriptionImg: "",
    //     src: "",
    //     tags: "",
    //     gh: "",
    // }
]